import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Import the CSS with Tailwind and custom font
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
